import { Type } from "class-transformer";
import { VbaTraceItem } from "./VbaTraceItem";

export class VbaTraceExport {
    errorMessage = "";
    @Type(() => VbaTraceItem)
    items: VbaTraceItem[];
    source = "";
}
